import { DefaultEnvironment } from './environment.model';

export const defaultEnvironment: DefaultEnvironment = {
  beneficiary: {
    weightFormat: '1.0-0',
  },
  systemType: ['pension'],
  features: {
    savingsOverview: {
      yearSelector: true,
      monthSelector: false,
    },
    investmentProfileFollowingRecommended: false,
    savingsSummaryInfo: false,
  },
};
